<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      addText="导出"
      :addBtnLoading="exporting"
      :handelAdd="handelExport"
      :ableSearch="ableSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'result'">
          {{ codeToText(record.result, loginState) }}
        </template>
        <template v-else-if="column.key === 'depart_id'">
          {{ codeToText(record.depart_id, Enum.dept.value) }}
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData } from '@/api/system_report/application_count'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { loginState } from '@/utils/common'
  import table_data_format from '@/components/table_data_format'
  import { fileExport } from '@/utils/download'

  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    true
  )
  const ableAdd = computed(() =>
    true
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'select',
      field: 'type',
      storeOptions: 'areaType',
      defaultValue: 3,
      label: '园区类型',
      width: '180px',
    },
    {
      type: 'date',
      field: 'date',
      label: '日期',
      defaultValue: dayjs().format('YYYY-MM-DD'),
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      align: 'left',
    },
    {
      title: '人员预约单审核已通过',
      dataIndex: 'person_check_agree',
      key: 'person_check_agree',
      align: 'left',
    },
    {
      title: '人员预约单审核未通过',
      key: 'person_check_disagree',
      dataIndex: 'person_check_disagree',
      align: 'left',
    },
    {
      title: '车辆预约单审核已通过',
      key: 'car_check_agree',
      dataIndex: 'car_check_agree',
      align: 'left',
    },
    {
      title: '车辆预约单审核未通过',
      key: 'car_check_disagree',
      dataIndex: 'car_check_disagree',
      align: 'left',
    },
    {
      title: '严管车辆备案审核已通过',
      dataIndex: 'registration_check_agree',
      key: 'registration_check_agree',
      align: 'left',
    },
    {
      title: '严管车辆备案审核未通过',
      dataIndex: 'registration_check_disagree',
      key: 'registration_check_disagree',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = [data]
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //导出
  const exporting = ref(false)
  async function handelExport() {
    exporting.value = true
    const formState = searchFormRef.value?.formState
    fileExport({
      onFinally: () => (exporting.value = false),
      name: `申请单数量统计${Enum.areaType.value[formState.type]}导出${
        formState.date
      }.xlsx`,
      url: `/api/statistics/application/countsExport?date=${formState.date}&type=${formState.type}`,
    })
  }
</script>
